import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { getLandingPathForRole } from '../../utils/roleUtils';

/**
 * RoleBasedRedirect - Redirects to role-based landing page
 * Used for fallback routes and generic entry points
 */
const RoleBasedRedirect = () => {
  const context = useContext(UserContext) || {};
  const { user, loadingUser } = context;

  if (loadingUser) {
    return (
      <div className="flex justify-center items-center min-h-screen text-xl text-white">
        Loading...
      </div>
    );
  }

  const landingPath = getLandingPathForRole(user?.role);
  return <Navigate to={landingPath} replace />;
};

export default RoleBasedRedirect;

